// cart-add-refresh.js
// created by ch — rewritten to remove the global window.fetch monkeypatch.
//
// WHY THE REWRITE:
//   The previous version replaced window.fetch for the whole page and turned
//   EVERY /cart/* mutation into a `cart-drawer:refresh`. Because the AppStle
//   Subscriptions/Bundles apps also write to the cart (to re-apply selling
//   plans / volume discounts) whenever the cart DOM re-renders, this created
//   a refresh -> AppStle re-mutate -> refresh feedback loop that froze the
//   main thread (the intermittent "Wait or Kill the page" on /cart). The
//   `__internalCall` guard that was meant to break the loop was dead code —
//   nothing ever set it.
//
// WHAT THIS DOES NOW:
//   Exposes a single, debounced helper, window.i150RefreshCartDrawer(), that
//   the i150 add-to-cart / subscription-selector / cross-sell code calls
//   explicitly after THEIR OWN cart writes. AppStle's background writes are
//   never intercepted, so no loop can form.
//
//   It dispatches the theme's real `cart-drawer:refresh` event (handled in
//   assets/cart-drawer.js -> refreshCartDrawer()), and briefly shows a spinner
//   over the drawer body to avoid an empty-state flash while the section HTML
//   is swapped in.

(function () {
  if (window.__i150CartAddRefreshInstalled) return;
  window.__i150CartAddRefreshInstalled = true;

  // Spinner / hide-contents styling used during a refresh so the drawer never
  // visibly flashes its empty state while we wait for fresh section HTML.
  var styleEl = document.createElement('style');
  styleEl.textContent = [
    '.wt-cart__drawer.i150-refreshing .wt-cart__drawer__body {',
    '  position: relative;',
    '}',
    '.wt-cart__drawer.i150-refreshing .wt-cart__drawer__body > *,',
    '.wt-cart__drawer.i150-refreshing .wt-cart__drawer__footer {',
    '  visibility: hidden !important;',
    '}',
    '.wt-cart__drawer.i150-refreshing .wt-cart__drawer__body::after {',
    '  content: "";',
    '  position: absolute;',
    '  top: 40%;',
    '  left: 50%;',
    '  width: 32px;',
    '  height: 32px;',
    '  margin: -16px 0 0 -16px;',
    '  border: 3px solid rgba(0,0,0,0.1);',
    '  border-top-color: #f07c1f;',
    '  border-radius: 50%;',
    '  visibility: visible !important;',
    '  animation: i150-spin 0.8s linear infinite;',
    '}',
    '@keyframes i150-spin {',
    '  to { transform: rotate(360deg); }',
    '}'
  ].join('\n');
  document.head.appendChild(styleEl);

  function setRefreshing(on) {
    var drawer = document.querySelector('.wt-cart__drawer');
    if (!drawer) return;
    drawer.classList.toggle('i150-refreshing', !!on);
  }

  var refreshTimer = null;
  var clearTimer = null;

  // Debounced refresh: collapses bursts of calls (e.g. add + discount, or
  // several quick line changes) into a single drawer refresh.
  window.i150RefreshCartDrawer = function (opts) {
    opts = opts || {};
    setRefreshing(true);

    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      document.dispatchEvent(
        new CustomEvent('cart-drawer:refresh', { bubbles: true })
      );

      // refreshCartDrawer() fetches sections asynchronously and exposes no
      // "done" hook, so reveal after a short fixed delay.
      clearTimeout(clearTimer);
      clearTimer = setTimeout(function () {
        setRefreshing(false);
      }, opts.revealDelay || 450);
    }, opts.delay || 60);
  };
})();
